import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Loader2 } from "lucide-react";
import { ApiService } from "../../services/api";

// Mesafeli satış ön bilgilendirme formu (28 Eki): siparişe özel metin sunucudan gelir (paket, tutar, taksit, alıcı);
// ödeme sayfasında ayrı kutuyla onaylanır, aynı metin siparişe kopyalanır ve ödeme sonrası e-postayla gider.
type OnBilgi = { surum: string; baslik: string; bolumler: { baslik: string; metin: string }[] };

const OnBilgilendirmePenceresi: React.FC<{
  acik: boolean;
  kapat: () => void;
  onayla: () => void;
  istek: { packageId: string; referralCode?: string; billing?: any };
}> = ({ acik, kapat, onayla, istek }) => {
  const [veri, setVeri] = useState<OnBilgi | null>(null);
  const [hata, setHata] = useState("");

  useEffect(() => {
    if (!acik || !istek.packageId) return;
    setVeri(null);
    setHata("");
    ApiService.getPaymentOnBilgilendirme(istek)
      .then(setVeri)
      .catch((err: any) => setHata(err?.message || "Form yüklenemedi. Tekrar deneyin."));
    // Pencere her açılışta güncel paket/tutar/alıcı bilgisiyle yeniden üretilir (yalnız açılışa bağlı)
  }, [acik]);

  if (!acik) return null;
  // Gövdeye çizilir: panelin <main>'inde transform var, "fixed" ona göre yerleşip ekran dışında kalıyordu
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50 p-0 sm:p-4" onClick={kapat}>
      <div
        className="bg-white w-full sm:max-w-2xl max-h-[90dvh] flex flex-col rounded-t-2xl sm:rounded-2xl shadow-xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="on-bilgi-baslik"
      >
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <h2 id="on-bilgi-baslik" className="text-base font-semibold text-slate-900">
            {veri?.baslik || "Mesafeli Satış Ön Bilgilendirme Formu"}
          </h2>
          <button type="button" onClick={kapat} className="text-slate-500 hover:text-slate-800 text-2xl leading-none px-2" aria-label="Kapat">
            ×
          </button>
        </div>
        <div className="overflow-y-auto px-5 py-4 text-sm leading-relaxed text-slate-700">
          {hata ? (
            <p className="text-red-600">{hata}</p>
          ) : !veri ? (
            <p className="flex items-center gap-2 text-slate-500"><Loader2 className="h-4 w-4 animate-spin" /> Hazırlanıyor…</p>
          ) : (
            <div className="space-y-3">
              {veri.bolumler.map((b) => (
                <section key={b.baslik}>
                  <h3 className="font-semibold text-slate-900 mb-0.5">{b.baslik}</h3>
                  <p>{b.metin}</p>
                </section>
              ))}
              <p className="text-xs text-slate-400">Sürüm: {veri.surum}</p>
            </div>
          )}
        </div>
        <div className="px-5 py-3 border-t">
          <button
            type="button"
            disabled={!veri}
            onClick={() => { onayla(); kapat(); }}
            className="w-full py-2.5 rounded-lg bg-violet-600 text-white font-medium hover:bg-violet-700 disabled:opacity-50"
          >
            Okudum, onaylıyorum
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default OnBilgilendirmePenceresi;
